import { ErrorState, ForbiddenState } from '@platform/ui-kit'
import { ApiError } from '@/lib/api'

/* ------------------------------------------------------------------
   حالت خطای پاسخ API
   ------------------------------------------------------------------
   🔴 نقصی که این کامپوننت بسته است.

   ۲۳ صفحه برای **هر** شکستِ درخواست همین را نشان می‌دادند:

       «خطایی رخ داد — در دریافت اطلاعات مشکلی پیش آمد.
        لطفاً دوباره تلاش کنید.»   [ تلاش دوباره ]

   ⚠️ برای ۴۰۳ این پیام هم غلط است و هم آزاردهنده: دسترسی‌نداشتن
   «مشکل» نیست، و «تلاش دوباره» هرگز جواب نمی‌دهد. کاربر دکمه را
   می‌زند، همان خطا را می‌گیرد، و فکر می‌کند سامانه خراب است — در
   حالی که سامانه دقیقاً درست کار کرده.

   🔴 نبودِ دسترسی یک **پاسخ** است، نه یک خطا. باید مثل پاسخ نمایش
   داده شود.

   ⚠️ ۴۰۱ عمداً اینجا نیست: لایهٔ `api` خودش کاربر را به صفحه ورود
   می‌فرستد، پس رسیدنش به اینجا یعنی چیز دیگری اشتباه شده.
   ------------------------------------------------------------------ */

export interface ApiErrorStateProps {
  error: unknown
  /** عنوان حالتِ خطای عمومی — روی ۴۰۳ اثری ندارد */
  title?: string
  /** توضیح جایگزین برای ۴۰۳ — مثلاً «برای دیدن پرونده پرسنلی…» */
  forbiddenDescription?: string
  onRetry?: () => void
}

export function ApiErrorState({
  error,
  title,
  forbiddenDescription,
  onRetry,
}: ApiErrorStateProps) {
  if (error instanceof ApiError && error.isForbidden) {
    /*
     | پیام خودِ Backend مقدم است: فقط او می‌داند کدام قاعده رد کرده
     | (محرمانگی، دامنه دید، سقف اختیار) و متن عمومی آن را پنهان
     | می‌کند.
     */
    return <ForbiddenState description={forbiddenDescription ?? error.message} />
  }

  const message = error instanceof Error ? error.message : undefined

  return (
    <ErrorState
      title={title}
      description={message}
      requestId={error instanceof ApiError ? error.requestId : null}
      onRetry={onRetry}
    />
  )
}
